import Helpers from './Helpers'
import BookingSummary from './bookingsummary/BookingSummary'
import FlexibleBooking from './FlexibleBooking'

class Reservation {
    constructor() {
        this.pets = document.querySelector('.reservation__pets')
        this.adultsDropDown = document.querySelector('.ddlAdults')
        this.babiesDropDown = document.querySelector('.ddlBabies')
        this.priceOptions = document.querySelectorAll('.priceOptions input[type="radio"]')

        this.flexibleBookingPrice = document.querySelector('.cancel-anytime__item--price.flexible')
        this.flexibleBookingRadio = document.querySelector('.cancel-anytime__item--radio.flex')

        this.standardBookingPrice = document.querySelector('.cancel-anytime__item--price.standard')
        this.standardBookingRadio = document.querySelector('.cancel-anytime__item--radio.standard')

        this.bookingSummary = new BookingSummary()
        this.flexibleBooking = new FlexibleBooking()

        this.initialiseElements()
        this.listeners()
        window.addEventListener('pageshow', () => {
            this.initialiseElements()
        })
    }

    initialiseElements() {
        if (this.pets && this.pets.value > 0) {
            this.bookingSummary.processLineItem('pet-price', 'Pet Fee', this.pets.value)
        }

        this.setSelectedPriceOptionData()

        if (this.flexibleBookingRadio && this.flexibleBookingRadio.checked) {
            this.setFlexBookingLineItem()
        }
    }

    listeners() {
        new Helpers(this.pets).eventListener(() => {
            this.setPetsLineItem()
        }, 'change')

        this.priceOptions.forEach((radio) => {
            radio.addEventListener('change', (e) => {
                this.handlePriceOption(e.target)
            })
        })

        new Helpers(this.flexibleBookingRadio).eventListener(() => {
            this.setFlexBookingLineItem()
        })

        new Helpers(this.standardBookingRadio).eventListener(() => {
            this.bookingSummary.processLineItem('cancel-anytime', 'Cancel anytime', 0)
        })
    }

    setPetsLineItem() {
        const petValue = parseFloat(this.pets.value) || 0
        const broRent = parseFloat(this.standardBookingPrice.getAttribute('data-standard-cost'))
        const cost = petValue + broRent        
        this.calculateFlexBookingControl(cost, broRent, false)
        this.bookingSummary.processLineItem('pet-price', 'Pet Fee', petValue)
    }

    setFlexBookingLineItem() {
        const price = this.flexibleBookingPrice.getAttribute('data-flex-cost')
        this.bookingSummary.processLineItem('cancel-anytime', 'Cancel anytime', price)
    }

    setSelectedPriceOptionData() {
        const option = this.getSelectedPriceOptionRadio()
        if (option) {
            this.handlePriceOption(option)
        }
    }

    getSelectedPriceOptionRadio() {
        return Array.from(this.priceOptions).find(radio => radio.checked)
    }

    handlePriceOption(selectedRadio) {
        const span = selectedRadio.closest('span')
        const rent = parseFloat(span.getAttribute('data-price'))
        const broRent = parseFloat(span.getAttribute('data-brorent'))
        const reducedBy = parseFloat(span.getAttribute('data-reduced-by'))

        this.bookingSummary.processLineItem('discounted', span.getAttribute('data-restriction'), -reducedBy)

        let costForFlex = rent
        if (this.pets) { costForFlex += parseFloat(this.pets.value) || 0 }        
        this.calculateFlexBookingControl(costForFlex, rent)

        this.setPartyControlsFromPriceModifier(span)
        this.handleSpecialOffer(broRent)
    }

    handleSpecialOffer(broRent) {
        const specialOffer = document.querySelector('.booking-summary__line-items--item[data-item-name="special-offer"]')
        if (specialOffer != null) {
            const soRate = specialOffer.getAttribute('data-item-so-rate')
            const discountAmount = (soRate / 100) * broRent
            const offerText = specialOffer.querySelector('.booking-summary__description').textContent.trim();
    
            this.bookingSummary.processLineItem('special-offer', offerText, -discountAmount, soRate)
        }
    }
    calculateFlexBookingControl(cost, broRent, updateStandardPrice = true) {

        this.flexibleBooking.calcFlexibleBookingControl(cost, broRent, updateStandardPrice).then(data => {
            const selectedPrice = this.flexibleBooking.getSelectedPrice().getAttribute('data-flex-cost') || 0
            this.bookingSummary.processLineItem('cancel-anytime', 'Cancel anytime', selectedPrice)
        })
    }

    setPartyControlsFromPriceModifier(span) {
        const adults = parseInt(span.getAttribute('data-adults'), 10)
        const babies = parseInt(span.getAttribute('data-babies'), 10)

        this.updateDropDown(this.adultsDropDown, adults, 1)

        if (this.babiesDropDown != null) {
            this.updateDropDown(this.babiesDropDown, babies, 0)
            this.babiesDropDown.style.display = babies === 0 ? 'none' : 'block'
        }
    }

    updateDropDown(dropdown, count, defaultValue) {
        dropdown.innerHTML = ''
        for (let i = defaultValue; i <= count; i++) {
            const option = document.createElement('option')
            option.value = i
            option.text = i
            if (i === defaultValue) {
                option.selected = true
            }
            dropdown.add(option)
        }
    }
    roundToTwoDecimalPlaces(price) {
        price = parseFloat(price);
        return price.toFixed(2);
    }
}

if (document.querySelector('.reservation')) {
    new Reservation()
}
